// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".response__date[data-v-62c2d531]{color:rgba(7,9,25,.5)}.response__content[data-v-62c2d531]{margin-left:56px}.header__direct-messages[data-v-62c2d531]{width:100%;background-color:#f8f9ff}.direct-message-block[data-v-62c2d531]{border-bottom:2px solid #eeeff8}.container__direct-messages[data-v-62c2d531]{max-height:50vh;overflow:auto}", ""]);
// Exports
module.exports = exports;
